
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.079 21.012A2.081 2.081 0 010 18.934v-7.672a2.252 2.252 0 012.25-2.25h19.5a2.252 2.252 0 012.25 2.25v7.67a2.087 2.087 0 01-2.081 2.079c-.297 0-.585-.063-.857-.187a2.061 2.061 0 01-1.087-1.162L18.409 15.5a.753.753 0 00-.7-.487H6.285a.754.754 0 00-.698.487l-1.562 4.164a2.089 2.089 0 01-1.946 1.348c.001 0 0 0 0 0zm.171-10.499a.75.75 0 00-.75.75v7.671a.58.58 0 001.121.203l1.562-4.163a2.263 2.263 0 012.1-1.46h11.428a2.263 2.263 0 012.102 1.459l1.566 4.162a.574.574 0 00.542.376.582.582 0 00.579-.579v-7.67a.75.75 0 00-.75-.75H2.25zM16.5 7.513a.75.75 0 01-.75-.75v-6a.75.75 0 011.5 0v6a.75.75 0 01-.75.75zM7.5 7.513a.75.75 0 01-.75-.75v-6a.75.75 0 011.5 0v6a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M16.5 24.013a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM7.5 24.013a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0v4.5a.75.75 0 01-.75.75zM12 7.513a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75zM12 3.013a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75zM12 19.513a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75zM12 24.013a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75z"}})])
          )
        }
      }
    